import type { Event } from '@patsnap/tahiti-core';
import type { FeatureLocatedState, GetClaimCompareMatchParams } from '../types';

export const FeatureLocatedService = Symbol.for('FeatureLocatedService');

export interface FeatureLocatedService {
    readonly onStatesChange: Event<FeatureLocatedState>;
    getModelData(): FeatureLocatedState;
    updateModelData(data: Partial<FeatureLocatedState>): void;

    setLocatedPatentInfo({ patentId, text }: { patentId: string; text: string; }): void;
    getFeatureMatchData(params: GetClaimCompareMatchParams): Promise<void>;
    markFeatureInDocument(wrapperClass?: string): void;
    scrollToNode(number: number): void;
}
